module.exports = __webpack_public_path__ + "static/credit-good-2df66976b099f59e051c642147c71fef.png";